export enum ViewState {
	LOADING = 'loading',
	SERVICE_FEE = 'service-fee',
	PAY = 'pay',
	PROCESSING = 'processing',
	ERROR = 'error',
}

export interface PaymentError {
	message: string;
	code?: string;
	details?: string;
}
